import { dao } from '@platform/dao';
import type { IRecord } from '@platform/core/types';
import { baseApi, listTag, run } from '@platform/state/api/baseApi';
import type { IMappingCandidatesArg } from './IMappingCandidatesArg';

/** Стеля запитів однієї вибірки (типи з малою кількістю записів після пропуску вже зв'язаних). */
const MAX_REQUESTS = 8;

/**
 * Записи для панелі «Зіставлення» без пошукового запиту: перші `limit` записів типів по черзі (сторінки по 50, за кодом), без
 * пропущених (сам запис і вже зв'язані); кешується зі списковими тегами цих типів.
 */
export const mappingApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    mappingCandidates: b.query<IRecord[], IMappingCandidatesArg>({
      queryFn: ({ ws, types, exclude, limit }) => run(async () => {
        const skip = new Set(exclude);
        const out: IRecord[] = [];
        let requests = 0;
        for (const rt of types) {
          for (let page = 1; out.length < limit && requests < MAX_REQUESTS; page += 1) {
            requests += 1;
            const chunk = await dao.records.list(ws, rt, { page, pageSize: 50, sort: 'code', facets: false });
            out.push(...chunk.items.filter((r) => !skip.has(r.id)));
            if (page * 50 >= chunk.total || !chunk.items.length) break;
          }
          if (out.length >= limit || requests >= MAX_REQUESTS) break;
        }
        return out.slice(0, limit);
      }),
      providesTags: (_r, _e, { types }) => types.map(listTag),
    }),
  }),
});

export const { useMappingCandidatesQuery } = mappingApi;
